import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import LeaderboardTable from "./leaderboard-table";
import {getWorldCupResults} from "../../../modules/result";

import "./leaderboard.css";

class Leaderboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gameID: -1,
            leaderboardData: [],
            gotData: false,
            gettingData: false
        }
    }


    async componentDidUpdate() {
        const {gotData, gettingData} = this.state;
        const {token} = this.props;

        if (!gotData) {
            if (gettingData) {
                return;
            }

            this.setState({gettingData: true});

            let worldCupResponse = await getWorldCupResults(token);

            if (worldCupResponse && worldCupResponse.data && worldCupResponse.data.success) {
                this.setState({leaderboardData: worldCupResponse.data.leaderboard_data, gotData: true});
                this.setState({gettingData: false});
            }
        }
    }

    render() {
        const {leaderboardData} = this.state;
        return (
            <div className='leaderboard_container'>
                <div className='leaderboard_title'>Hall of Fame!</div>
                <LeaderboardTable leaderboard_data={leaderboardData} ></LeaderboardTable>
            </div>

        )
    }
}


const withState = connect(state => {
    const {user} = state;

    return {
       
        token: user.token
    };
});

export default withRouter(withState(Leaderboard));


// WEBPACK FOOTER //
// ./src/components/containers/leaderboard/leaderboard.js